var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealMadridHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29473",
    "data-name": "Group 29473",
    transform: "translate(-87 -822.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(87 822.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-real-madrid",
    transform: "translate(97 825.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50661",
    "data-name": "Path 50661",
    d: "M17.25,22.083a4.049,4.049,0,0,0-2.1,2.314l.438.438,5.973,5.973a5.027,5.027,0,0,0,2.071-1.584c.19-.247-.066-.671.077-.952l-.262-.527L20.3,24.6Z",
    transform: "translate(-2.794 -10.85)",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50662",
    "data-name": "Path 50662",
    d: "M25.371,9.1A1.371,1.371,0,0,0,24,10.474c0,.022.005.042.006.064l.451-.064,2.135.61a1.349,1.349,0,0,0,.149-.61A1.371,1.371,0,0,0,25.371,9.1Z",
    transform: "translate(-7.602 -3.801)",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50663",
    "data-name": "Path 50663",
    d: "M21.371,9.1a1.358,1.358,0,0,0-1.329,1.691l2.243-.32.444.127c0-.042.013-.084.013-.127A1.371,1.371,0,0,0,21.371,9.1Z",
    transform: "translate(-5.43 -3.801)",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50664",
    "data-name": "Path 50664",
    d: "M15.167,12.043l1.295.431,1.351-.193a1.363,1.363,0,0,0-2.646-.239Zm8.859-.279a1.367,1.367,0,0,0-2.538.71c0,.023.005.044.007.067l1.364.39Z",
    transform: "translate(-2.806 -4.887)",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50665",
    "data-name": "Path 50665",
    d: "M21.312,3.931a1.092,1.092,0,0,0-.228.023,2.743,2.743,0,0,0-1.6-.9V2.1H18.57v.955a2.743,2.743,0,0,0-1.6.9,1.092,1.092,0,0,0-.228-.023A2.75,2.75,0,0,0,14,6.673a1.326,1.326,0,0,0,.324.855,1.949,1.949,0,0,0,.612.462c.073.037.142.064.21.091a.463.463,0,0,0,.535.366.517.517,0,0,0,.178-.078,5.86,5.86,0,0,1,3.167-.781,5.86,5.86,0,0,1,3.167.781.46.46,0,0,0,.64-.11.507.507,0,0,0,.073-.178c.069-.027.137-.055.21-.091a1.949,1.949,0,0,0,.612-.462,1.326,1.326,0,0,0,.324-.855A2.75,2.75,0,0,0,21.312,3.931Zm-5.47,3.418a2,2,0,0,1-.494-.178,1.061,1.061,0,0,1-.329-.242.349.349,0,0,1-.105-.256,1.811,1.811,0,0,1,1.522-1.8,2.667,2.667,0,0,0-.151.882,2.744,2.744,0,0,0,.329,1.293A6.45,6.45,0,0,0,15.842,7.349Zm4.666-.539a8.064,8.064,0,0,0-2.961,0A1.778,1.778,0,0,1,17.2,5.759a1.828,1.828,0,1,1,3.656,0A1.778,1.778,0,0,1,20.507,6.81Zm2.527.119a1.061,1.061,0,0,1-.329.242,2,2,0,0,1-.494.178,6.45,6.45,0,0,0-.772-.3,2.744,2.744,0,0,0,.329-1.293,2.667,2.667,0,0,0-.151-.882,1.811,1.811,0,0,1,1.522,1.8A.349.349,0,0,1,23.035,6.929Z",
    transform: "translate(-2.172)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50666",
    "data-name": "Path 50666",
    d: "M16.4,5.1h.914V8.759H16.4ZM16.855,11a5.941,5.941,0,1,1-5.941,5.941A5.948,5.948,0,0,1,16.855,11m0-.914a6.855,6.855,0,1,0,6.855,6.855,6.86,6.86,0,0,0-6.855-6.855Z",
    transform: "translate(0 -1.629)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50667",
    "data-name": "Path 50667",
    d: "M24.054,25.673a4.973,4.973,0,0,1-1.046,3.066l-.653-.653a4.1,4.1,0,0,0-.914-5.74l-2.413,2.413-2.413-2.413a4.1,4.1,0,0,0-.914,5.74l-.653.653a5.019,5.019,0,0,1,.914-7.047,4.921,4.921,0,0,1,.791-.5l1.818,1.818.458-.077h.535L21.3,21.19a4.921,4.921,0,0,1,.791.5A5,5,0,0,1,24.054,25.673Z",
    transform: "translate(-2.172 -10.365)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50668",
    "data-name": "Path 50668",
    d: "M23.146,28.392l.722.576a3.2,3.2,0,1,1,0-3.537l-.722.576a2.285,2.285,0,1,0,0,2.385Z",
    transform: "translate(-4.344 -11.89)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50669",
    "data-name": "Path 50669",
    d: "M22.914,34.57H22V30h2.285v.914H22.914Z",
    transform: "translate(-6.516 -15.149)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50670",
    "data-name": "Path 50670",
    d: "M23,33h1.828v.914H23Z",
    transform: "translate(-7.059 -16.778)",
    fill: "#f1c40f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealMadridHighlighted);
export default __webpack_public_path__ + "static/media/realMadridHighlighted.abd979187914f177064a5fc39b4846b3.svg";
export { ForwardRef as ReactComponent };